import React from 'react'
import EmploymentRequirements from '../components/EmploymentRequirements'
import FloatingCTA from '../components/FloatingCTA'
import FilterBar from '../components/FilterBar'
import SalaryBreakdown from '../components/SalaryBreakdown'
import PayrollInsights from '../components/PayrollInsights'
import BusinessGuide from '../components/BusinessGuide'



const Insights = () => {
  return (
    <>
    <FilterBar/>
    <BusinessGuide/>
    <SalaryBreakdown/>
    <PayrollInsights/>
    <EmploymentRequirements/>
    <FloatingCTA/>
    </>
  )
}

export default Insights